// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2R4ry","head":"Table_head__32C-W","col":"Table_col__3V4_A"};